
const spj = [
    {
        id : 'SPJ001',
        invoice : 'OF001',
        guest : 'Mr Guest',
        start_travel : '01-01-2025',
        pax : 3,
        driver : 'Mr Driver',

    },
    {
        id : 'SPJ002',
        invoice : 'OF002',
        guest : 'Mr Guest',
        start_travel : '01-01-2025',
        pax : 3,
        driver : 'Mr Driver',

    },
    {
        id : 'SPJ003',
        invoice : 'OF003',
        guest : 'Mr Guest',
        start_travel : '01-01-2025',
        pax : 3,
        driver : 'Mr Driver',

    },
    {
        id : 'SPJ004',
        invoice : 'OF004',
        guest : 'Mr Guest',
        start_travel : '01-01-2025',
        pax : 3,
        driver : 'Mr Driver',

    },
    {
        id : 'SPJ005',
        invoice : 'OF005',
        guest : 'Mr Guest',
        start_travel : '01-01-2025',
        pax : 3,
        driver : 'Mr Driver',

    }
]

export default spj